import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './core/pages/LoginPage/LoginPage';
import DashboardPage from './core/pages/DashboardPage/DashboardPage';
import CameraDetailPage from './core/pages/CameraDetailPage/CameraDetailPage';
import Loading from './core/components/Loading/Loading';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import UserManagementPage from './core/pages/UserManagementPage/UserManagementPage';
import RegistrationPage from './core/pages/RegistrationPage/RegistrationPage';
import EmailVerificationPage from './core/pages/EmailVerificationPage/EmailVerificationPage';
import TermsGuard from './core/components/TermsGuard/TermsGuard'; // <--- ИМПОРТ НОВОГО КОМПОНЕНТА
import NotificationsPage from './core/pages/NotificationsPage/NotificationsPage';
import StoreDetailPage from './core/pages/StoreDetailPage/StoreDetailPage';
import axios from 'axios'; 
import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/es';

const PrivateRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    useEffect(() => { setIsAuthenticated(!!localStorage.getItem('token')); }, []);
    if (isAuthenticated === null) return <Loading name="Auth checking..." />;
    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
    const { i18n } = useTranslation();
    const [isLanguageSet, setIsLanguageSet] = useState(false);

    useEffect(() => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') dayjs.locale('ru');
        else dayjs.locale('en');
    }, [i18n.language]);

    useEffect(() => {
        const savedLang = localStorage.getItem('i18nextLng');

        if (savedLang && savedLang.length === 2) {
            setIsLanguageSet(true);
            return;
        }

        const detectLanguageByIP = async () => {
            try {
                const response = await axios.get('https://ipapi.co/json/');
                const country = response.data.country_code;
                let lang = 'en'; 
                if (['RU', 'BY', 'KZ', 'UA', 'KG', 'UZ'].includes(country)) {
                    lang = 'ru';
                }
                i18n.changeLanguage(lang);
            } catch (error) {
                console.warn("Не удалось определить язык по IP, установлен EN", error);
                i18n.changeLanguage('en');
            } finally {
                setIsLanguageSet(true);
            }
        };

        detectLanguageByIP();
    }, [i18n]);

    if (!isLanguageSet) return <Loading name="Setting language..." />;

    return (
        <>
            <Router>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegistrationPage />} />
                    <Route path="/verify-email/:uid/:token" element={<EmailVerificationPage />} />
                    
                    {/* ОБЕРТКА MARШРУТОВ В TERMS GUARD */}
                    <Route path="/dashboard" element={<PrivateRoute><TermsGuard><DashboardPage /></TermsGuard></PrivateRoute>} />
                    <Route path="/camera/:cameraId" element={<PrivateRoute><TermsGuard><CameraDetailPage /></TermsGuard></PrivateRoute>} />
                    <Route path="/users" element={<PrivateRoute><TermsGuard><UserManagementPage /></TermsGuard></PrivateRoute>} />
                    <Route path="/notifications" element={<PrivateRoute><TermsGuard><NotificationsPage /></TermsGuard></PrivateRoute>} />
                    <Route path="/store/:storeId" element={<PrivateRoute><TermsGuard><StoreDetailPage /></TermsGuard></PrivateRoute>} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </Router>
            <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} />
        </>
    );
}
export default App;